module.exports = __webpack_public_path__ + "static/media/contacto.46fc8c9e.png";